let activeInput = null;

const keyboardWrapper = document.getElementById("keyboard-wrapper");
const keyboardToggle = document.getElementById("keyboard-toggle");

const Keyboard = window.SimpleKeyboard.default;

const keyboard = new Keyboard(".keyboard", {
    layoutName: "default",

    layout: {
        default: [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m",
            "{space} {enter}"
        ],

        shift: [
            "! @ # $ % ^ & * ( ) {bksp}",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M",
            "{space} {enter}"
        ],

        numeric: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "{bksp} 0 {enter}"
        ]
    },

    display: {
        "{bksp}": "⌫",
        "{enter}": "Enter",
        "{space}": "Space",
        "{shift}": "⇧"
    },

    onChange: (input) => {
        if (!activeInput) return;

        activeInput.value = input;

        activeInput.dispatchEvent(
            new Event("input", {
                bubbles: true,
            })
        );
    },

    onKeyPress: (button) => {
        if (!activeInput) return;

        switch (button) {
            case "{shift}":
                keyboard.setOptions({
                    layoutName:
                        keyboard.options.layoutName === "default"
                            ? "shift"
                            : "default",
                });
                break;

            case "{bksp}":
                activeInput.focus();
                break;

            case "{enter}":
                activeInput.dispatchEvent(
                    new KeyboardEvent("keydown", {
                        key: "Enter",
                        bubbles: true,
                    })
                );
                break;
        }
    },
});

function moveModalsAboveKeyboard() {
    const keyboardHeight = keyboardWrapper.offsetHeight;

    document.querySelectorAll(".keyboard-modal").forEach((modal) => {
        modal.style.transform = "";

        const rect = modal.getBoundingClientRect();
        const keyboardTop = window.innerHeight - keyboardHeight;

        if (rect.bottom > keyboardTop) {
            const overlap = rect.bottom - keyboardTop + 20;
            modal.style.transform = `translateY(-${overlap}px)`;
        }
    });
}

function resetModalPositions() {
    document.querySelectorAll(".keyboard-modal").forEach((modal) => {
        modal.style.transform = "";
    });
}

function openKeyboard() {
    keyboardWrapper.classList.remove("hidden");

    requestAnimationFrame(() => {
        moveModalsAboveKeyboard();
    });
}

function closeKeyboard() {
    keyboardWrapper.classList.add("hidden");
    resetModalPositions();
}

keyboardToggle?.addEventListener("click", () => {
    if (keyboardWrapper.classList.contains("hidden")) {
        openKeyboard();
    } else {
        closeKeyboard();
    }
});

document.addEventListener("focusin", (e) => {
    const target = e.target;

    if (
        !target.matches(
            'input[type="text"], input[type="search"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"], input[type="url"], textarea'
        )
    ) {
        return;
    }

    activeInput = target;

    keyboard.setInput(target.value || "");

    const isNumeric =
        target.inputMode === "numeric" ||
        target.type === "number";

    keyboard.setOptions({
        layoutName: isNumeric ? "numeric" : "default",
    });

    openKeyboard();
});

document.addEventListener("input", (e) => {
    if (e.target === activeInput) {
        keyboard.setInput(activeInput.value || "");
    }
});

document.addEventListener("click", (e) => {
    if (e.target.closest("#keyboard-wrapper")) return;
    if (e.target.closest("#keyboard-toggle")) return;
    if (e.target.closest("input, textarea")) return;

    activeInput = null;
    closeKeyboard();
});

document.addEventListener("keydown", () => {
    closeKeyboard();
});

document.addEventListener("livewire:navigated", () => {
    activeInput = null;
    closeKeyboard();
});

window.addEventListener("resize", () => {
    if (!keyboardWrapper.classList.contains("hidden")) {
        moveModalsAboveKeyboard();
    }
});